import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format number as Nigerian Naira
export function formatNaira(amount, showSymbol = true) {
  if (amount === null || amount === undefined) return showSymbol ? '₦0' : '0';
  
  const formatted = new Intl.NumberFormat('en-NG', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(amount));
  
  return showSymbol ? `₦${formatted}` : formatted;
}

// Format percentage
export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(decimals)}%`;
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-NG', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

// Capitalize first letter
export function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Get initials from name
export function getInitials(firstName, lastName) {
  const first = firstName?.charAt(0)?.toUpperCase() || '';
  const last = lastName?.charAt(0)?.toUpperCase() || '';
  return `${first}${last}`;
}

// Calculate Nigerian PAYE tax (client-side for preview)
export function calculatePAYE(grossAnnual, deductions = 0) {
  // Consolidated Relief Allowance
  const cra = 800000 + (0.20 * grossAnnual);
  
  // Taxable income
  const taxableIncome = Math.max(0, grossAnnual - deductions - cra);
  
  // Tax bands
  const bands = [
    { limit: 300000, rate: 0.07 },
    { limit: 300000, rate: 0.11 },
    { limit: 500000, rate: 0.15 },
    { limit: 500000, rate: 0.19 },
    { limit: 1600000, rate: 0.21 },
    { limit: Infinity, rate: 0.24 }
  ];
  
  let remaining = taxableIncome;
  let totalTax = 0;
  
  for (const band of bands) {
    if (remaining <= 0) break;
    const taxableInBand = Math.min(remaining, band.limit);
    totalTax += taxableInBand * band.rate;
    remaining -= band.limit;
  }
  
  return {
    grossAnnual,
    consolidatedRelief: cra,
    taxableIncome,
    annualPAYE: totalTax,
    monthlyPAYE: totalTax / 12
  };
}

// Validate email
export function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

// Debounce function
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
